import { useAppSelector } from 'shared/hooks/redux/hooks';
import { isMobileApp } from 'webui/utils/version';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { getDeviceSpec } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { selectorSelectedDevice } from 'entities/device/lib';
export function useShowWiFiConfiguration() {
    const selected_device = useAppSelector(selectorSelectedDevice);
    if (selected_device == null) {
        return false;
    }
    if (!isMobileApp()) {
        return false;
    }
    const device_type = selected_device.device_type?.code ?? '';
    if (device_type == 'other') {
        return true;
    }
    const has_z3k_settings = LegacyDevice.has_capability(selected_device.capabilities, Capability.has_z3k_settings);
    const _has_wifi = getDeviceSpec(device_type, selected_device.hardware_type?.code ?? '').network.has_wifi;
    const show_wifi_configuration = selected_device.show_wifi_configuration ?? false;
    if (has_z3k_settings && _has_wifi) {
        if (['SMART+', 'CLIMATIC'].includes(device_type)) {
            return show_wifi_configuration;
        }
        //Если вдруг туда поставили модуль WiFi
        if (['H2000+', 'C2000+'].includes(device_type)) {
            return selected_device.z3k_config?.wifi_settings?.is_enabled ?? false;
        }
        return true;
    }
    const has_wifi = LegacyDevice.has_any_capability(selected_device?.capabilities, [
        Capability.has_wifi,
        Capability.has_wifi_v2,
    ]);
    if (!has_z3k_settings && has_wifi) {
        // This branch is for ZONT H-2
        return show_wifi_configuration;
    }
    return false;
}
